module.exports = __webpack_public_path__ + "static/media/profile-retraite.82c269c6.svg";